import { CharacteristicModel, EquipmentCharacteristicsModel } from '../models/equipment-characteristics.model';
import { CharacteristicView } from '../types/component-type.type';

export const EquipmentCharacteristicsPresenterFactory = (equipmentCharacteristicsModel: EquipmentCharacteristicsModel,
                                                         selectedEquipmentCharacteristicsInitialValues: string) => {
  const initialValues = selectedEquipmentCharacteristicsInitialValues.split('');
  return new EquipmentCharacteristicsPresenter(
    'plan.attributesView.characteristics.label',
    equipmentCharacteristicsModel,
    [initialValues[0], initialValues[1]],
  );
};

export class EquipmentCharacteristicsPresenter {

  public readonly label: string;
  public readonly isEditable: boolean;
  public readonly line: CharacteristicPresenter;
  public readonly column: CharacteristicPresenter;

  constructor(label: string, equipmentCharacteristics: EquipmentCharacteristicsModel, initialValues: [string, string]) {
    this.label = label;
    this.isEditable = equipmentCharacteristics.isEditable === undefined ? true : equipmentCharacteristics.isEditable;
    this.line = new CharacteristicPresenter(
      equipmentCharacteristics.lineName,
      sortByNumber(this.onlyCharacteristicsOfType(equipmentCharacteristics.characteristics, 'Ligne')),
      initialValues[0]
    );
    this.column = new CharacteristicPresenter(
      equipmentCharacteristics.columnName,
      sortByNumber(this.onlyCharacteristicsOfType(equipmentCharacteristics.characteristics, 'Colonne')),
      initialValues[1]
    );
  }

  private onlyCharacteristicsOfType(characteristicModels: CharacteristicModel[], type: 'Ligne' | 'Colonne') {
    return characteristicModels.filter((it) => it.type === type);
  }
}

export class CharacteristicPresenter {
  public readonly label: string;
  public readonly initialValue: string;
  public readonly values: CharacteristicModel[];

  constructor(label: string, options: CharacteristicView[], initialValue: string) {
    this.label = label;
    this.values = options;
    this.initialValue = initialValue;
  }

}


const sortByNumber = (characteristicViews: CharacteristicView[]) => characteristicViews.sort(
  (a, b) => {
    if (a.number < b.number) return -1;
    if (a.number > b.number) return 1;
    return 0;
  });
